const identityComparator = function (a, b) {
    return a === b;
};

const sort = (array, sortKey) =>
    array.sort((a, b) => {
        const keyA = a[sortKey].toUpperCase();
        const keyB = b[sortKey].toUpperCase();
        if (keyA < keyB) {
            return -1;
        }
        if (keyA > keyB) {
            return 1;
        }

        return 0;
    });

export default {
    /**
        Creates an array of unique values that are included in all given arrays.
        It accepts comparator which is invoked to compare elements of the arrays.
        The order and references of result values are determined by the first array.
        The comparator is invoked with two arguments: (arrVal, othVal).
        If omitted, the comparator will use === to compare both keys.
        This doesnt mutate the input arrays.
    */
    intersect(a, b, comparator = identityComparator) {
        //Check if a & b are valid arrays
        if ((typeof a !== 'object' && a.constructor !== Array) || (typeof b !== 'object' && b.constructor !== Array))
            throw 'Array Utils - intersect: Either a or b are not arrays';

        const result = [];
        a.forEach(x => {
            b.forEach(y => {
                if (comparator(x, y)) {
                    result.push(x);
                }
            });
        });

        return result;
    },
    sort,
};
